import classNames from 'classnames';
import React from 'react';
import { TFunctionResult } from 'i18next';
import { generateDataAuto } from 'src/js/util/automation';

export interface StatsRowViewModel {
  name: string;
  value: string | number | TFunctionResult;
  value2?: string | number | TFunctionResult;
  twoColumns?: boolean;
  className?: string;
}

export const StatisticRow: React.FunctionComponent<StatsRowViewModel> = ({
  name,
  value,
  value2,
  twoColumns,
  className,
  ...rest
}) => {
  return (
    <div {...rest} className={classNames('box mk-stats-row', twoColumns && 'twoColumns', className)}>
      <span>{name}</span>
      <span>
        <div className="dataColumn tnum" title={value?.toString()} data-auto={generateDataAuto('stats', 'row value')}>
          {value?.toString()}
        </div>
      </span>
      {twoColumns && (
        <span>
          <div className="dataColumn tnum" title={value2?.toString()}>
            {value2?.toString()}
          </div>
        </span>
      )}
    </div>
  );
};
